module.exports = __webpack_public_path__ + "img/keep-afloat-by-outsourcing-web-development-during-recession.28402ebb.jpg";